<template>
  <div id="rate-box" class="bd-1 bd-gray-medium br-8 pa-16 bg-white">
    <div class="text-lg-sb mb-16 tc">Thank You For Traveling With Us</div>
    <SectionLocalDesigner v-if="designer" :designer-id="designer?.id" :designer-info="designer" />
    <div class="bd-1 bd-gray-medium br-8 pa-16 mt-8">
      <div class="tc mb-12 text-lg-sb">How would you rate your trip?</div>
      <div class="flex justify-center">
        <Rate :rate="0" :read-only="false" :size="32" @update:rate="handleUpdateRate" @selectRate='selectRate' />
      </div>
    </div>
    <DJButton id="button-bookable-trip-plan-rate-trip" class="wp-100 mt-24" size="large" @click='goToFeedback()'>
<!--      <router-link class="" :to="{ name: 'feedback', params: { id: dataTrip.id, point: rate * 2 } }">-->
        Rate my trip with {{ dataTrip?.designer?.name }}
<!--      </router-link>-->
    </DJButton>
    <div class="tc pt-8 fw-500 fs-14 lh-20 gray-700">We'd love to hear your feedback.</div>
  </div>
</template>

<script setup>
import { ref, computed } from "vue"
import Rate from '~/components/ui/rate/Rate.vue'
import SectionLocalDesigner from '~/components/pages/TripPlanDetail/sections/SectionLocalDesigner/SectionLocalDesigner.vue'
import DJButton from '~/components/ui/button/Button.vue'
import { useTripPlanStore } from '~/store/pinia/tripPlan'
import { useRouter } from 'vue-router'

const router = useRouter()
const tripPlanStore = useTripPlanStore()

const dataTrip = computed(() => tripPlanStore.dataTrip)
const designer = computed(() => tripPlanStore.designer)
const rateUpdate = ref(null)
function handleUpdateRate(value) {
  rateUpdate.value = value
}

const goToFeedback = () => {
  router.push({ name: 'feedback', params: { id: dataTrip.value.id, point: 9 } })
}

const selectRate = (point) => {
  router.push({ name: 'feedback', params: { id: dataTrip.value.id, point: (point * 2) } })
}
</script>

<style lang="scss" scoped>
a:link,
a:visited,
a:hover,
a:active,
a:focus {
  color: unset;
}
</style>
